$('.responsive').slick({
  dots: false,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 3,
  prevArrow:'<span class="icon_lift"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M31.6673 20H8.33398" stroke="#9A277F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.0007 31.6666L8.33398 19.9999L20.0007 8.33325" stroke="#9A277F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
  nextArrow: '<span class="icon_right"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.33268 20H31.666" stroke="#0A4E88" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.9993 31.6666L31.666 19.9999L19.9993 8.33325" stroke="#0A4E88" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',   
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('#tabs-nav li:first-child a').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();

  $('#tabs-nav li a').click(function(){
    $('#tabs-nav li a').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();
    var activeTab = $(this).attr('href');
    //  alert(activeTab)
    $('.tab-content').each(function(){
    var tab  = $(this).attr('href') ;
    //alert(tab);
    if(activeTab == tab ){
      $(this).fadeIn();   
    }
    })  
  return false;
}); 


$('.toggle').click(function(e) {
  	e.preventDefault();
    let $this = $(this);
    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $(this).removeClass('active');
        $this.next().slideUp(350);
    } else {
        $this.parent().parent().find('li .inner').removeClass('show');
        $this.parent().parent().find('a.toggle').removeClass('active');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.next().toggleClass('show');
        $(this).toggleClass('active');
        $this.next().slideToggle(350);
    }
});


$('.itg_testimonial').slick({
  dots: false,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow:'<span class="icon_lift"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M31.6673 20H8.33398" stroke="#9A277F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.0007 31.6666L8.33398 19.9999L20.0007 8.33325" stroke="#9A277F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
  nextArrow: '<span class="icon_right"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.33268 20H31.666" stroke="#0A4E88" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.9993 31.6666L31.666 19.9999L19.9993 8.33325" stroke="#0A4E88" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',   
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



